module.exports = __webpack_public_path__ + "img/zwaardboten--white.a4d997d7.svg";